import React, { ReactNode, useEffect, useState } from 'react';
import Table from '../../table/Table';
import { displayHits, displayMatchDetails, getMatchesHeader, sliceHitsByPage } from './helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'react-bootstrap';
import sendToPrinter from '../../common/printing/printing';
import UserAuditStamp from '../../profile/UserAuditStamp';
import { InternalApiScreeningManualSearchHit } from '../../api-internal';

interface Props {
  hits: InternalApiScreeningManualSearchHit[];
}

const MatchedHits = ({ hits }: Props) => {
  const [page, setPage] = useState(0);
  const [body, setBody] = useState<ReactNode[]>([]);
  const [fetching, setFetching] = useState(true);
  const [printing, setPrinting] = useState(false);

  const initiatePrinting = () => {
    setPage(0);
    setFetching(true);
    setPrinting(true);
  };

  useEffect(() => {
    if (printing && !fetching) {
      sendToPrinter().then(() => {
        setPrinting(false);
      });
    }
  }, [printing, fetching, setPrinting]);

  useEffect(() => {
    setPage(0);
  }, [hits]);

  useEffect(() => {
    setFetching(true);
    Promise.all(displayHits(sliceHitsByPage(hits, printing ? hits.length : 20, page), displayMatchDetails)).then(
      (newBody) => {
        setBody(newBody);
        setFetching(false);
      }
    );
  }, [hits, page, printing, setPage]);

  return (
    <Table
      title='Matches'
      className='table-fixed'
      page={page}
      size={printing ? hits.length : 20}
      total={hits.length}
      items={body}
      actions={() => (
        <Button className='right-button btn-white' variant='info' size='sm' onClick={initiatePrinting}>
          <FontAwesomeIcon icon={faDownload} className='me-2' />
          Export All
        </Button>
      )}
      filters={() => printing && <UserAuditStamp />}
      fetchPage={setPage}
      header={() => getMatchesHeader()}
      body={() => body}
    />
  );
};

export default MatchedHits;
